/*
  BANGLE-UP — CUSTOM : bloc « Craquez pour : » du tiroir panier (portage Focal).

  Le tiroir panier de Prestige est entièrement re-généré à chaque modification du
  panier : cet élément est donc recréé à chaque fois. Il récupère les
  recommandations via la section `bu-cart-recommendations`, et garde le résultat
  en mémoire pour un même contenu de panier (attribut cart-key) : changer une
  quantité ne provoque ni nouvelle requête ni clignotement.
*/
const buCartRecommendationsCache = new Map();

class BuCartRecommendations extends HTMLElement {
  async connectedCallback() {
    const productId = this.getAttribute('product-id');

    if (!productId) {
      return;
    }

    const cacheKey = `${productId}|${this.getAttribute('cart-key') || ''}`;
    let html = buCartRecommendationsCache.get(cacheKey);

    if (html === undefined) {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}recommendations/products?product_id=${productId}&limit=10&section_id=bu-cart-recommendations&intent=related`);
        const list = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.bu-cart-reco__list');
        html = list && list.children.length > 0 ? list.innerHTML : '';
      } catch (error) {
        html = '';
      }

      buCartRecommendationsCache.set(cacheKey, html);
    }

    const target = this.querySelector('[data-bu-reco-list]');

    if (!this.isConnected || !target || html === '') {
      return;
    }

    target.innerHTML = html;
    this.hidden = false;
  }
}

if (!window.customElements.get('bu-cart-recommendations')) {
  window.customElements.define('bu-cart-recommendations', BuCartRecommendations);
}
